import React, { SVGProps } from "react";

export const CodatLogo: React.FC<SVGProps<SVGSVGElement>> = ({
  height = "2rem",
  ...props
}) => (
  <svg
    height={height}
    {...props}
    viewBox="0 0 260 67"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M100.606 28.749C104.46 28.749 107.794 30.9711 109.72 34.2505L109.797 34.3731L115.409 31.2162L115.348 31.0937C112.779 25.6993 106.922 22.4658 100.53 22.4658C95.4682 22.4658 91.1559 24.2282 88.0975 27.2318C85.0543 30.2355 83.2805 34.4651 83.2805 39.3997C83.2805 49.1462 90.3301 56.2109 100.301 56.2109C106.738 56.2109 112.534 52.8701 115.164 47.8283L115.226 47.7056L109.613 44.4415L109.552 44.5641C107.916 47.6597 104.124 49.9431 100.377 49.9431C94.4743 49.9431 90.1466 45.3303 90.1466 39.3997C90.1466 33.469 94.5966 28.749 100.606 28.749Z"
      fill="#482DEB"
    />
    <path
      d="M186.578 27.4617C184.04 24.504 180.63 22.4812 176.057 22.4812C166.851 22.4812 159.985 29.9596 159.985 39.3537C159.985 48.7477 166.79 56.2875 176.118 56.2875C180.645 56.2875 184.147 54.3106 186.7 51.307V55.5213H193.429V10.252H186.578V27.4617ZM176.944 50.0044C170.812 50.0044 166.836 45.2077 166.836 39.3384C166.836 33.469 170.812 28.7337 176.944 28.7337C183.076 28.7337 187.052 33.5763 187.052 39.3384C187.052 45.1005 183.076 50.0044 176.944 50.0044Z"
      fill="#482DEB"
    />
    <path
      d="M226.475 27.4617C223.86 24.504 220.297 22.4658 215.71 22.4658C206.443 22.4658 199.638 29.5305 199.638 39.1545C199.638 48.7784 206.381 56.2569 215.71 56.2569C220.297 56.2569 223.86 54.28 226.475 51.3223V55.4753H233.02V23.2474H226.475V27.4617ZM216.612 50.0044C210.48 50.0044 206.504 45.2077 206.504 39.3997C206.504 33.5916 210.419 28.7336 216.612 28.7336C222.805 28.7336 226.781 33.5916 226.781 39.3384C226.781 45.0851 222.683 50.0044 216.612 50.0044Z"
      fill="#482DEB"
    />
    <path
      d="M257.523 48.242L257.66 48.1654L260 53.529L259.908 53.5904C257.523 55.3987 254.174 56.2875 251.008 56.2875C247.461 56.2875 244.8 55.1688 243.026 53.0387C241.252 50.9085 240.396 47.8283 240.396 43.9205L240.457 11.9071H247.185V23.2627H258.196V29.1168H247.185V44.043C247.185 45.9586 247.522 47.4451 248.286 48.4566C249.036 49.4527 250.228 50.0044 251.972 50.0044C254.006 50.0044 255.81 49.2381 257.523 48.242Z"
      fill="#482DEB"
    />
    <path
      d="M137.766 22.4199C127.734 22.4199 120.746 30.0822 120.746 39.3537C120.746 48.6251 127.734 56.3488 137.766 56.3488C147.798 56.3488 154.786 48.7477 154.786 39.3537C154.786 29.9596 147.798 22.4199 137.766 22.4199ZM137.766 49.9431C132.047 49.9431 127.597 45.2077 127.597 39.3383C127.597 33.469 132.047 28.7336 137.766 28.7336C143.485 28.7336 147.935 33.5916 147.935 39.3383C147.935 45.0851 143.485 49.9431 137.766 49.9431Z"
      fill="#482DEB"
    />
    <path
      d="M23.2745 0.0457631L6.13209 11.8458C5.96388 11.9531 5.96388 12.1983 6.13209 12.3209L12.7383 16.857C12.83 16.9183 12.9676 16.9183 13.0594 16.857L23.6109 9.59307C23.6874 9.54709 23.7332 9.45514 23.7332 9.3632V0.290959C23.7332 0.0610878 23.4733 -0.0768347 23.2745 0.0457631Z"
      fill="#482DEB"
    />
    <path
      d="M60.2201 41.0394L37.0679 56.9924C36.9915 57.0537 36.9456 57.1304 36.9456 57.2223V66.2945C36.9456 66.5244 37.2056 66.6623 37.3891 66.5244L60.5412 50.5714C60.6177 50.5101 60.6635 50.4334 60.6635 50.3415V41.2693C60.6635 41.0394 60.4036 40.9015 60.2201 41.0394Z"
      fill="#482DEB"
    />
    <path
      d="M47.6041 40.3958C47.6959 40.4571 47.8335 40.4571 47.9253 40.3958L54.5161 35.8596C54.6843 35.7524 54.6843 35.5072 54.5161 35.3846L37.3737 23.5845C37.1902 23.4466 36.9303 23.5845 36.9303 23.8144V32.8866C36.9303 32.9786 36.9762 33.0705 37.0526 33.1165L47.6041 40.3958Z"
      fill="#482DEB"
    />
    <path
      d="M0.443469 17.5006C0.259965 17.378 0 17.5006 0 17.7305V26.8181C0 26.91 0.0458761 27.002 0.122336 27.0479L23.2745 43.001C23.458 43.1389 23.718 43.001 23.718 42.7711V33.6989C23.718 33.6069 23.6721 33.515 23.5956 33.469L0.443469 17.5006Z"
      fill="#482DEB"
    />
  </svg>
);
